const buildVideoRenderer = (content: string, mimeType: string, label: string) => {
  const cleaned = (content || '').replace(/\s+/g, '')
  const src = cleaned ? `data:${mimeType};base64,${cleaned}` : ''
  const fallback = cleaned ? '' : `No ${label} data available.`

  return `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <style>
      :root {
        color-scheme: light;
      }
      body {
        margin: 0;
        background: #000000;
        color: #94a3b8;
        font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100vw;
        height: 100vh;
        overflow: hidden;
      }
      video {
        width: 100%;
        height: 100%;
        object-fit: contain;
        background: #000000;
      }
      .empty {
        font-size: 13px;
        background: #111827;
        padding: 12px 16px;
        border-radius: 6px;
      }
    </style>
  </head>
  <body>
    ${src ? `<video controls preload="metadata" src="${src}"></video>` : `<div class="empty">${fallback}</div>`}
  </body>
</html>`
}

const mp4Renderer = (content: string) => buildVideoRenderer(content, 'video/mp4', 'MP4')

export const collectAssetReferences = () => []

export default mp4Renderer
